<template>
    <div class="my-drawer-mask" :class="show_flag?'show-drawer-mask':'hide-drawer-mask'">
        <div class="my-drawer flex-box col nopadding box-shadow" :style="{'width': width+'px'}">
            <div class="flex-box-bd fillw " style="position: relative;"><slot></slot></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "myDrawer",
        components:{
        },
        model:{ //通过v-model传过来的参数
            prop: 'show_flag',
            event: 'changeShow'
        },
        props:{
            show_flag: {
                default: false,
                type: Boolean,
            },
            close_drawer_only:{
                default: false,
                type: Boolean,
            },
            width:{
                default: '1000'
            }
        },
        methods: {
            onClose() {
                if(this.close_drawer_only){
                    this.$emit('onClose');
                }
                else{
                    this.$base.linkBack();
                }
            },
        }
    }
</script>

<style scoped>
.my-drawer-mask{
    position: fixed;
    left: 0;
    bottom: 0;
    top:0;
    right: 0;
    z-index: 2000;
    transform: translateX(100%);
}
.my-drawer{
    position: fixed;
    right: 0;
    height: 100%;
    background-color: #fff;
    border-top-left-radius: 5px;
    overflow: hidden;

}
.show-drawer-mask{
    transition: all 0.5s;
    transform: translateX(0);
}
.hide-drawer-mask{
    transition: all 0.5s;
    transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/myDrawer.vue